<template>
  <div class="c-article-detail__buttonrow">
    <form class="c-form" name="sAddToBasket" method="post" action="https://www.partsdata.de/checkout/addArticle">
      <Input />
      <input type="hidden" name="sActionIdentifier" value="">
      <input type="hidden" name="sAddAccessories" id="sAddAccessories" value="">
      <input type="hidden" name="sAdd" value="CU-CHAIN-120">
      <input id="customizingGroupId" type="hidden" name="customizingGroupId" value="">
      <Button>In den Warenkorb</Button>
    </form>
  </div>
</template>

<script>
import Button from '@/components/atoms/Button.vue'
import Input from '@/components/atoms/Input'
export default {
  name: 'AddToBasket',
  components: { Input, Button }
}
</script>

<style scoped lang="sass">
  .c-article-detail__buttonrow
    margin: 0
    float: left
    left: 25.3em
    bottom: -0.26em
    right: auto
    form
      margin: 0.5em 0 0 0

    input
      width: 5em
      padding: .62em .9em
      margin-right: 0.5em
</style>
